import React from 'react';

import { ResourceTableTitle, ResourceTableTitleContainer } from '@/components/common';

interface IResourcesSimpleTableContainerProps {
  tableComponentSlot: React.ReactElement;
  items: any[];
  tableTitle: string;
  tableTitleActionSlot?: React.ReactElement;
  tableHeadSectionSlot?: React.ReactElement;
}

const ResourcesSimpleTableContainer = (props: IResourcesSimpleTableContainerProps): React.ReactElement => {
  return (
    <>
      <ResourceTableTitleContainer>
        <ResourceTableTitle>{props.tableTitle}</ResourceTableTitle>
        {props.tableTitleActionSlot}
      </ResourceTableTitleContainer>
      {props.tableHeadSectionSlot}
      {props.tableComponentSlot}
    </>
  );
};

export { ResourcesSimpleTableContainer };
